import styled from 'styled-components';
import { media } from 'styled-bootstrap-grid';

export const MetadataRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  width: 100%;
  margin-bottom: 10px;
`;

export const DateContainer = styled.div`
  font-size: 16px;
  font-weight: ${({ theme }) => theme.fontWeights.medium};
  flex-grow: 0;

  ${media.xl`
    min-width: 130px;
  `}
`;

export const OptionRow = styled.div`
  color: ${({ theme }) => theme.defaultColors.fontSecondary};
  margin-bottom: 20px;
  font-size: 15px;
`;
